module.exports = __webpack_public_path__ + "img/Middle-Semi-Elliptical-Attachment-L-38.abc3d10d.png";